export default __webpack_public_path__ + "static/N0170-30d81bd05070840f7201154cba1e8d24.png";